import { render, staticRenderFns } from "./LongTextAction.vue?vue&type=template&id=09581482&scoped=true"
import script from "./LongTextAction.vue?vue&type=script&lang=ts"
export * from "./LongTextAction.vue?vue&type=script&lang=ts"
import style0 from "./LongTextAction.vue?vue&type=style&index=0&id=09581482&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09581482",
  null
  
)

export default component.exports